//@flow

import {saveTikTokIntegrationApi, getTikTokIntegrationApi} from './api';
import type {SaveTikTokIntegrationRequest} from './api';

import type {TikTokIntegration} from '../../../entities/tiktok-integration';

export function saveTikTokIntegrationService(
  request: SaveTikTokIntegrationRequest
): Promise<TikTokIntegration> {
  return saveTikTokIntegrationApi(request).toPromise();
}

export function getTikTokIntegrationService(): Promise<TikTokIntegration> {
  return getTikTokIntegrationApi().toPromise();
}
